// **Lizenzen** — die Liste der Vorlagen (docs/11 8e). Einem Mandanten werden
// Plätze je Vorlage zugewiesen (Reiter „Lizenz" des Mandanten), der
// Tenant-Admin verteilt sie auf Konten. Eine Lizenz schneidet stärker als die
// Rolle: Was hier fehlt, hat das Konto nicht.
//
// Eine Seite, kein Dialog: `/licenses`, `/licenses/new`, `/licenses/<id>`.

import { useLicenseTemplates } from "../../api/queries";
import { PageHead } from "../../app/page-head";
import { eur } from "../../lib/format";
import { Link, useNavigate } from "../../router/router";
import { ErrorNote } from "../../ui/badge";
import { Card } from "../../ui/card";
import { rightsSummary } from "./license-model";

export function LicensesView() {
  const navigate = useNavigate();
  const query = useLicenseTemplates();
  const templates = query.data;
  return (
    <>
      <PageHead
        title="Lizenzen"
        hint="Vorlagen für Benutzer-Lizenzen. Einem Mandanten weist du Plätze je Vorlage zu, der Tenant-Admin verteilt sie auf Benutzer."
        actions={<Link className="pf-btn pf-btn--primary" to="/licenses/new">Neue Lizenz</Link>}
      />
      {query.isError ? <ErrorNote error={query.error} /> : null}
      {templates ? (
        <Card
          title={`${templates.length} ${templates.length === 1 ? "Vorlage" : "Vorlagen"}`}
          hint="Eine Lizenz schneidet stärker als die Rolle: Was sie nicht erlaubt, hat der Benutzer nicht — auch ein Admin nicht, soweit es um Nutzung geht."
          flush
        >
          {templates.length ? (
            <div className="pf-table-wrap">
              <table className="pf-table">
                <thead><tr><th>Lizenz</th><th className="pf-hide-phone">Erlaubt</th><th className="pf-num">Preis / Monat</th><th className="pf-num">Plätze</th></tr></thead>
                <tbody>
                  {templates.map((tpl) => {
                    const href = `/licenses/${tpl.id}`;
                    return (
                      <tr key={tpl.id} data-href={href} onClick={() => navigate(href)}>
                        <td><strong>{tpl.name}</strong><div className="pf-sub mono">{tpl.key}</div></td>
                        <td className="pf-hide-phone pf-sub">{rightsSummary(tpl.rights)}</td>
                        <td className="pf-num">{eur(tpl.price_eur_month)}</td>
                        <td className="pf-num">{tpl.seats_total}<div className="pf-sub">{tpl.tenants.length} {tpl.tenants.length === 1 ? "Mandant" : "Mandanten"}</div></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : <div className="pf-empty">Noch keine Lizenz. Lege eine an — z. B. „Basis" (Chat) und „Entwickler" (Chat, Code, Agents).</div>}
        </Card>
      ) : null}
    </>
  );
}
